import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import parseHtml from "html-react-parser";
import { Header2 } from "./Header.jsx";
import  Header  from "./Header.jsx";
import { useNavigate } from "react-router-dom";
import { FaArrowRight, FaArrowLeft, FaCheck } from "react-icons/fa";
// import Webcam from "react-webcam";
import { API_URL, API_URL_PHOTO, SECRET_SESSION, API_URL_LOG } from "../constants.js";
import {
  encrypt,
  decrypt,
  decrypt_res,
  encrypt_res,
} from "./shares/GlobalFunction.jsx";
import ConfirmationModal from "./shares/ConfirmationModal.js";
import NoCopyText from "./shares/NoCopyText.js";
import Loader from "./shares/Loader.jsx";
import AlertProgres from "./shares/AlertProgres.js";
import axiosInstance from "./shares/axiosConfig.js";
import Camera from "./shares/Camera.js";
import moment from "moment-timezone";
import AlertModal from "./shares/AlertModal.js";

const baseURL = API_URL + "/login/info";

function KonfirmasiToken() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);
  const [listUjian, setListUjian] = useState([]);
  const [dataProjek, setDataProjek] = useState(null);
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("token");

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 640);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [isLoading, setIsLoading] = useState(true);
  const [effectsCompleted, setEffectsCompleted] = useState(0);
  const [isAlertProgresOpen, setAlertProgresOpen] = useState(false);
  const [isAlertModalOpen, setAlertModalOpen] = useState(false);
  const [catatanPengawas, setCatatan] = useState('');
  const [isStopModalOpen, setModalStopOpen] = useState(false);
  const [titleStopModal, setTitleStop] = useState("");

  let userData = localStorage.getItem("user");
  if (userData) {
    userData = JSON.parse(decrypt(userData));
    // console.log(userData);
  } else {
    navigate("/login");
  }
  let kamera = localStorage.getItem("kamera");

  const [hasError, setHasError] = useState(false);

  const [post, setPost] = React.useState(null);

  React.useEffect(() => {
    axios.post(baseURL).then((response) => {
      response.data.res = JSON.parse(
        decrypt_res(response.data.res, SECRET_SESSION)
      );
      setPost(response.data.res);
      setEffectsCompleted((prev) => prev + 1);
    });
    axios.post(API_URL + "/peserta/info_projek", {
      id_projek: userData.id_projek
    }, {headers: {Authorization: `Bearer ${accessToken}`}})
    .then((response) => {
      setDataProjek(response.data.res);
      setEffectsCompleted((prev) => prev + 1);
    })
  }, []);

  const [Subtest, setSubtest] = React.useState(null);
  React.useEffect(() => {
    const payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: userData.id_ujian || 0,
      username: userData.nopes,
      kode_akses: userData.kode_akses,
      timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    };

    const encryptedPayload = encrypt_res(
      JSON.stringify(payload),
      SECRET_SESSION
    );
    axiosInstance
      .post(API_URL + "/peserta/subtest", {
        data: encryptedPayload,
        // id_projek: userData.id_projek,
        // id_siswa: userData.id_siswa,
      })
      .then((response) => {
        let decResponse = JSON.parse(
          decrypt_res(response.data.data, SECRET_SESSION)
        );

        // Check for access denied response
        // if (decResponse.length > 0 && decResponse[0].error_message) {
        //   alert(decResponse[0].error_message);
        //   navigate("/peserta/logout");
        //   return;
        // }

        if (decResponse.length > 0) {
          // console.log(decResponse);
          // console.log(listUjian);
          // console.log(userData);
          setSubtest(decResponse[0]);
        } else {
          //tampilkan dulu informasi jika anda sudah mengerjakan semua tes kemudian baru diarahkan ke halaman login
          //alert("Anda sudah mengerjakan semua tes");
          //navigate("/login");
          setAlertModalOpen(true);

          // setTimeout(() => {
          //   //navigate to logout
          //   navigate("/peserta/logout");
          //   setAlertModalOpen(false);
          // });
        }
        setEffectsCompleted((prev) => prev + 1);
      });
  }, [navigate, userData.id_projek, userData.id_siswa]);

  React.useEffect(() => {
    const payload = {
      id_siswa: userData.id_siswa
    };
    axiosInstance
      .post(API_URL + "/peserta/progress_siswa", payload)
      .then((response) => {
        // console.log(response.data.res);
        setListUjian(response.data.res);
      })
  }, [navigate, userData.id_siswa]);

  useEffect(() => {
    if (effectsCompleted >= 2) {
      setIsLoading(false);
    }
  }, [effectsCompleted]);

  //generate 5 digit random number
  // eslint-disable-next-line no-unused-vars
  const [genToken, setGenToken] = useState(
    Math.floor(10000 + Math.random() * 90000)
  );

  const [token, setToken] = useState();
  //set token only number
  const handleToken = (e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      setToken(e.target.value);
    }
  };
  const toInputToken = () => {
    //ganti caption button jadi loading
    let btnSubmit = document.getElementById("btnSubmit");
    btnSubmit.innerHTML = "Loading ...";
    btnSubmit.disabled = true;
    document.getElementById("token").disabled = true;

    //cek token valid
    if (userData.pengawas == 1 && false){
      const payload = {
        id_kelompok_ujian: userData.id_kelompok_ujian,
        input_token: token
      }
      const encryptedPayload = encrypt_res(
        JSON.stringify(payload),
        SECRET_SESSION
      );
      axiosInstance.post(API_URL + "/peserta/check_token", {
        data: encryptedPayload
      })
      .then((response) => {
        if (response.data.match){
          // axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
          //   id_siswa: userData.id_siswa,
          //   nopes: userData.nopes,
          //   nama_siswa: userData.nama_siswa,
          //   id_projek: userData.id_projek,
          //   type: 'log',
          //   keterangan: `${userData.nopes} mengisikan token yang valid`,
          //   timeStamp: Math.floor(Date.now() / 1000)
          // })
          const payload = {
            id_siswa: userData.id_siswa,
            nopes: userData.nopes,
            nama_siswa: userData.nama_siswa,
            id_projek: userData.id_projek,
            type: 'log',
            keterangan: `${userData.nopes} mengisikan token yang valid`,
            timeStamp: Math.floor(Date.now() / 1000)
          }
          const encryptedPayload = encrypt_res(
            JSON.stringify(payload),
            SECRET_SESSION
          );
          axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
            data: encryptedPayload
          })
          //set mulai ujian
          handleOpenModal();
        }else {
          document.getElementById("token").disabled = false;
          document.getElementById("token").focus();
          const payload = {
            id_siswa: userData.id_siswa,
            nopes: userData.nopes,
            nama_siswa: userData.nama_siswa,
            id_projek: userData.id_projek,
            type: 'log',
            keterangan: `${userData.nopes} mengisikan token yang tidak valid`,
            timeStamp: Math.floor(Date.now() / 1000)
          }
          const encryptedPayload = encrypt_res(
            JSON.stringify(payload),
            SECRET_SESSION
          );
          axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
            data: encryptedPayload
          })
          setHasError(true);
          //set error caption to document.getElementById("token")
    
          btnSubmit.innerHTML = "Mulai Tes";
          btnSubmit.disabled = false;
    
          return;
        }
      })
    }else {
      if (parseInt(token) !== genToken) {
        // alert("Token tidak valid !");
        document.getElementById("token").disabled = false;
        document.getElementById("token").focus();
        const payload = {
          id_siswa: userData.id_siswa,
          nopes: userData.nopes,
          nama_siswa: userData.nama_siswa,
          id_projek: userData.id_projek,
          type: 'log',
          url: window.location.href,
          kategori: "Mulai Tes",
          sub_kategori: "Token", 
          keterangan: `${userData.nopes} mengisikan token yang tidak valid`,
          timeStamp: Math.floor(Date.now() / 1000)
        }
        const encryptedPayload = encrypt_res(
          JSON.stringify(payload),
          SECRET_SESSION
        );
        axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
          data: encryptedPayload
        })
        setHasError(true);
        //set error caption to document.getElementById("token")
  
        btnSubmit.innerHTML = "Mulai Tes";
        btnSubmit.disabled = false;
  
        return;
      } else {
        const payload = {
          id_siswa: userData.id_siswa,
          nopes: userData.nopes,
          nama_siswa: userData.nama_siswa,
          id_projek: userData.id_projek,
          type: 'log',
          url: window.location.href,
          kategori: "Mulai Tes",
          sub_kategori: "Token", 
          keterangan: `${userData.nopes} mengisikan token yang valid`,
          timeStamp: Math.floor(Date.now() / 1000)
        }
        const encryptedPayload = encrypt_res(
          JSON.stringify(payload),
          SECRET_SESSION
        );
        axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
          data: encryptedPayload
        })
        //set mulai ujian
        handleOpenModal();
      }
    }
    // navigate("/peserta/confirmtoken");
  };

  const webcamRef = useRef(null);
  // const [capturedImage, setCapturedImage] = useState(null);
  const [webcamReady, setWebcamReady] = useState(false);
  const headerRef = useRef();

  const capture = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot({
        width: 480,
        height: 320,
      });
      return imageSrc;
      // axiosInstance.post(API_URL_PHOTO + "/peserta/save_image", {
      //   id_projek: userData.id_projek,
      //   id_siswa: userData.id_siswa,
      //   id_ujian: id_ujian,
      //   nopes: userData.nopes,
      //   image: imageSrc,
      // });
    } else {
      console.error("Webcam reference is null");
      return null
    }
  };

  const handleConfirmStop = () => {
    setModalStopOpen(false);
    navigate('/peserta/logout');
  }
  const [isModalOpen, setModalOpen] = useState(false);
  const handleOpenModal = () => {
    // if (userData.pengawas == 1) {
      const payload = {
        id_projek: userData.id_projek,
        id_siswa: userData.id_siswa,
        nopes: userData.nopes,
        password: userData.kode_akses,
        id_ujian: 0,
        token: accessToken
      };
    
    // Encrypt payload following the app pattern
    const encryptedPayload = encrypt_res(
      JSON.stringify(payload),
      SECRET_SESSION
      );
    axiosInstance
      .post(API_URL + "/peserta/checkAccessStatus", {
        data: encryptedPayload,
      })
      .then((response) => {
        // Decrypt the response
        const decryptedResponse = response.data.res;
        
        // Set the access status
        // setAccessStatus(decryptedResponse);
        
        // Log the response to console
        // console.log("Access Status Check Response:", decryptedResponse);
        
        // Check for status - but not implementing the stopping logic yet
        if (decryptedResponse && decryptedResponse.length > 0) {
          const statusCheck = decryptedResponse[0];
          // console.log(`Access Status ID: ${statusCheck.id_akses_ujian}, Status: ${statusCheck.nama_akses_ujian}, Notes: ${statusCheck.text_catatan}`);
          if (userData.pengawas == 0){
            setModalOpen(true);
          }else if((statusCheck.id_akses_ujian === 21 || statusCheck.id_akses_ujian === 44) && userData.pengawas == 1) {
            // Test is stopped - to be implemented later
            // navigate("/peserta/logout");
            setCatatan(statusCheck['text_catatan']);
            setTitleStop("Catatan Penghentian Ujian");
            setModalStopOpen(true);
          }else{
            setModalOpen(true);
          }
          // Here you would eventually implement the stopping logic
          // if (statusCheck.id_akses_ujian === 21) {
          //   // Test is stopped - to be implemented later
          // }
        }
      })
      .catch((error) => {
        console.error("Error checking access status:", error);
      });
    // }else {
    //   setModalOpen(true);
    // }
  };
  const handleConfirm = () => {
    const payload_log = {
      id_siswa: userData.id_siswa,
      nopes: userData.nopes,
      nama_siswa: userData.nama_siswa,
      id_projek: userData.id_projek,
      type: 'log',
      url: window.location.href,
      kategori: "Proses Tes",
      sub_kategori: "Token",
      keterangan: `${userData.nopes} masuk ke subtes ${Subtest.nama_projek}`,
      timeStamp: Math.floor(Date.now() / 1000)
    }
    const encryptedPayload_log = encrypt_res(
      JSON.stringify(payload_log),
      SECRET_SESSION
    );
    axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
      data: encryptedPayload_log
    })
    setModalOpen(false);
    setAlertProgresOpen(true);

    const payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_projek_ujian: Subtest.id_projek_ujian,
      id_paket_soal: Subtest.id_paket_soal,
      timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    };

    const encryptedPayload = encrypt_res(
      JSON.stringify(payload),
      SECRET_SESSION
    );
    axiosInstance
      .post(API_URL + "/peserta/mulaites", {
        data: encryptedPayload,
      })
      .then((response) => {
        let decResponse = JSON.parse(
          decrypt_res(response.data.data, SECRET_SESSION)
        );
        let id_ujian_exist = localStorage.getItem("id_ujian");
        if (
          id_ujian_exist &&
          parseInt(id_ujian_exist) !== parseInt(decResponse[0].id_ujian)
        ) {
          localStorage.removeItem("mulai_ujian");
          localStorage.removeItem("id_ujian");
          localStorage.removeItem("statusJawaban");
          localStorage.removeItem("tampilPertanyaan");
          localStorage.removeItem("tampilJawaban");
          localStorage.removeItem("soalAktif");
          localStorage.removeItem("canBack");
          localStorage.removeItem("waktuMengerjakan");
          localStorage.removeItem("idSoal");
        }
        if (dataProjek && dataProjek.kamera !== 0){
          if (webcamRef.current){
            var captureImage = capture();
          }else if (headerRef.current){
            var captureImage = headerRef.current.capture();
          }
          if (captureImage){
            const payload_capture = {
              id_projek: userData.id_projek,
              id_siswa: userData.id_siswa,
              id_ujian: 0,
              nopes: userData.nopes,
              image: captureImage,
              timeStamp: Math.floor(Date.now() / 1000)
            }
            const encryptedPayload_capture = encrypt_res(
              JSON.stringify(payload_capture),
              SECRET_SESSION
            );
            axiosInstance.post(API_URL_PHOTO + "/peserta/save_image", {
              data: encryptedPayload_capture
            });
            const encryptedData = encrypt(Subtest.id_projek_ujian.toString());
            localStorage.setItem("mulai_ujian", encryptedData);
            localStorage.setItem("mulai_ujian_tanpa_enkripsi", Subtest.id_projek_ujian.toString());
            localStorage.setItem("id_ujian", decResponse[0].id_ujian);
            if (Subtest.tipe_tes === 1) navigate(`/peserta/start_test?username=${userData.nopes}&event=${userData.id_projek}`);
            else if (Subtest.tipe_tes === 2) {
              if (parseInt(Subtest.jenis_tes) === 20)
                navigate(`/peserta/start_test_kraeplin?username=${userData.nopes}&event=${userData.id_projek}`);
              else navigate(`/peserta/start_test2?username=${userData.nopes}&event=${userData.id_projek}`);
            }
          } else{
            // setTitleStop("Kamera tidak menyala");
            // setCatatan("Harap pastikan kamera pada halaman ujian menyala")
            // setModalStopOpen(true);
            const payload_log = {
              id_siswa: userData.id_siswa,
              nopes: userData.nopes,
              nama_siswa: userData.nama_siswa,
              id_projek: userData.id_projek,
              type: 'log',
              url: window.location.href,
              kategori: "Proses Tes",
              sub_kategori: "Pindah Subtes",
              remaining_time: 0,
              keterangan: `${userData.nopes} kamera gagal menangkap gambar peserta`,
              timeStamp: Math.floor(Date.now() / 1000)
            }
            const encryptedPayload_log = encrypt_res(
              JSON.stringify(payload_log),
              SECRET_SESSION
            );
            axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
              data: encryptedPayload_log
            })
            const encryptedData = encrypt(Subtest.id_projek_ujian.toString());
            localStorage.setItem("mulai_ujian", encryptedData);
            localStorage.setItem("mulai_ujian_tanpa_enkripsi", Subtest.id_projek_ujian.toString());
            localStorage.setItem("id_ujian", decResponse[0].id_ujian);
            if (Subtest.tipe_tes === 1) navigate(`/peserta/start_test?username=${userData.nopes}&event=${userData.id_projek}`);
            else if (Subtest.tipe_tes === 2) {
              if (parseInt(Subtest.jenis_tes) === 20)
                navigate(`/peserta/start_test_kraeplin?username=${userData.nopes}&event=${userData.id_projek}`);
              else navigate(`/peserta/start_test2?username=${userData.nopes}&event=${userData.id_projek}`);
            }
          }
        } else {
          const encryptedData = encrypt(Subtest.id_projek_ujian.toString());
          localStorage.setItem("mulai_ujian", encryptedData);
          localStorage.setItem("mulai_ujian_tanpa_enkripsi", Subtest.id_projek_ujian.toString());
          localStorage.setItem("id_ujian", decResponse[0].id_ujian);
          if (Subtest.tipe_tes === 1) navigate(`/peserta/start_test?username=${userData.nopes}&event=${userData.id_projek}`);
          else if (Subtest.tipe_tes === 2) {
            if (parseInt(Subtest.jenis_tes) === 20)
              navigate(`/peserta/start_test_kraeplin?username=${userData.nopes}&event=${userData.id_projek}`);
            else navigate(`/peserta/start_test2?username=${userData.nopes}&event=${userData.id_projek}`);
          }
        }
      });
  };
  // console.log(listUjian);
  const handleCancel = () => {
    const payload_log = {
      id_siswa: userData.id_siswa,
      nopes: userData.nopes,
      nama_siswa: userData.nama_siswa,
      id_projek: userData.id_projek,
      type: 'log',
      url: window.location.href,
      kategori: "Mulai Tes",
      sub_kategori: "Token",
      keterangan: `${userData.nopes} menutup dialog masuk subtes`,
      timeStamp: Math.floor(Date.now() / 1000)
    }
    const encryptedPayload_log = encrypt_res(
      JSON.stringify(payload_log),
      SECRET_SESSION
    );
    axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
      data: encryptedPayload_log
    })
    setModalOpen(false);
    let btnSubmit = document.getElementById("btnSubmit");
    document.getElementById("token").disabled = false;
    document.getElementById("token").focus();
    btnSubmit.innerHTML = "Mulai Tes";
    btnSubmit.disabled = false;
  };

  const subtesPilihan = listUjian?.find(
    (item) => Number(item.urut) === Number(Subtest?.urut)
  );

  if (isLoading) {
    let temp = `/peserta/confirmtoken?username=${userData.username}&event=${userData.id_projek}`
    return <Loader destination={temp}/>;
  }

  return (
    <div className="App">
      <NoCopyText>
        <ConfirmationModal
          isOpen={isModalOpen}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          title={"Konfirmasi Mulai Tes"}
          subtitle={
            "Apakah Anda yakin untuk memulai tes ini? Silahkan klik 'Ya, Lanjutkan' jika Anda sudah siap."
          }
        />
        <AlertProgres
          isOpen={isAlertProgresOpen}
          title={"Sedang diproses ..."}
          subtitle={""}
        />
        <AlertModal
          isOpen={isStopModalOpen}
          onConfirm={handleConfirmStop}
          title={titleStopModal}
          subtitle={catatanPengawas}
          btn_text="Logout"
        />
        <AlertModal
          isOpen={isAlertModalOpen}
          onConfirm={() => {
            navigate("/peserta/logout");
            setAlertModalOpen(false);
          }}
          title={"Perhatian"}
          subtitle={
            "Anda sudah mengerjakan semua subtes. Silahkan klik 'Ya, Lanjutkan' untuk keluar."
          }
        />
        <div 
          className="App-header"
          // style={{ backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='150' height='50'><text x='0' y='20' font-size='15' fill='gray' fill-opacity='0.3' transform='rotate(-10, 75, 25)'>${userData.nopes}</text></svg>")` }}
        >
          {isMobile ? (
            <Header app_name={post && post.alamat} camera={post && kamera && post.camera && kamera != 0} ref={headerRef}/>
          ): (
            <Header2 app_name={post && post.alamat} camera={post && kamera && post.camera && kamera != 0} ref={headerRef}/>
          )}
          {isMobile ? (
            <div className="w-full overflow-x-auto absolute top-4 px-4">
              <div className="flex w-max">
                {listUjian &&
                  listUjian.map((ujian, i) => (
                    <div
                      key={i}
                      className={`relative text-white px-4 py-3 rounded-lg ${
                        i > 0 ? "-ml-6" : ""
                      } ${Subtest && i + 1 === Subtest.urut ? "z-10": "z-5"}`
                    }
                    style={{
                      backgroundColor: Subtest && i + 1 === Subtest.urut ? '#2D7DBE' : '#FFFFFF',
                      color: Subtest && i + 1 === Subtest.urut ? '#FFFFFF' : '#000000'
                    }}
                    >
                      <div className={`flex flex-col truncate overflow-hidden whitespace-nowrap ${i > 0 ? "ml-8" : "pl-0"}`}
                        style={{maxWidth: "200px"}}>
                        <span className="text-base font-semibold">{ujian.nama_projek}</span>
                        <div className="flex gap-2 text-xs opacity-90">
                          {`Durasi ${ujian.durasi_ujian} menit`} &nbsp;|&nbsp;{" "}
                          {`${ujian.jumlah_soal} soal`}
                        </div>
                      </div>

                      {/* Panah di kanan kecuali elemen terakhir */}
                      {i < listUjian.length - 1 && (
                        <div className="absolute top-1/2 -right-5 transform -translate-y-1/2 z-11">
                          <div className="h-[64px] h-0 border-t-[25px] border-b-[25px] border-l-[25px] border-t-transparent border-b-transparent border-l-[#2D7DBE]"></div>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          ): null}
          <div
            className="flex flex-row w-[90%] h-[80%] gap-5 p-5"
            style={{
              marginTop: "70px",
            }}
          >
            <div
              className="login-container hidden sm:block w-1/4 h-[80%] contentLogin z-10 bg-white border-1 border-grey-800 rounded-xl shadow-xl p-5"
              style={{
                minHeight: "200px"
              }}
            >
              <span style={{ fontSize: "16px", fontWeight: 600, fontFamily: "'DM Sans', sans-serif" }}>
                Daftar Subtes
              </span>
              {listUjian.map((ujian, index) => (
                <div
                  key={index}
                  className="Subtest-card"
                  style={{
                    backgroundColor: Subtest && index + 1 === Subtest.urut ? '#CCDCDB' : '#FFFFFF'
                  }}
                >
                  <div className="flex flex-row w-full items-center justify-between">
                    <div className="w-[95%]" style={{ 
                      fontWeight: 600, 
                      fontSize: '16px', 
                      color: '#000000'
                      }}>
                      {ujian.nama_projek}
                    </div>
                    <div className="w-[5%] mr-2">
                      {/* {Subtest && index + 1 < Subtest.urut && (
                        <span 
                          className="inline-flex items-center justify-center w-5 h-5 text-sm font-medium text-white rounded-full"
                          style={{backgroundColor: '#01B224'}}
                          >
                          <FaCheck className="w-2" />
                        </span>
                      )} */}
                      {listUjian && listUjian[index].status_ujian == 1 && (
                        <span 
                          className="inline-flex items-center justify-center w-5 h-5 text-sm font-medium text-white rounded-full"
                          style={{backgroundColor: '#01B224'}}
                          >
                          <FaCheck className="w-2" />
                        </span>
                      )}
                    </div>
                  </div>
                  <div style={{ fontWeight: 300, fontSize: '13px', 
                    color: '#000000'
                    }}>
                    {/* {`Durasi ${ujian.durasi_ujian} menit |\t${ujian.jumlah_soal} soal`} */}
                    {`Durasi ${ujian.durasi_ujian} menit`} &nbsp;|&nbsp; {`${ujian.jumlah_soal} soal`}
                  </div>
                </div>
              ))}
            </div>
            <div
              className="login-container w-full h-[100%]  Bg-tutwuri contentLogin z-10 bg-white border-1 border-grey-800 rounded-xl shadow-xl p-5"
              style={{
                minHeight: "200px",
                // maxHeight: "600px"
              }}
            >
              <div
                className={`overflow-y-scroll border text-left  px-4 py-3 mb-3 rounded relative panduan-height`}
              >
                <div className="" role="alert">
                  {Subtest && parseHtml(Subtest.panduan)}
                </div>
              </div>
              <form onSubmit={(event) => event.preventDefault()}>
              {isMobile ? (
                <div className="flex flex-row w-full">
                  <Camera webcamRef={webcamRef} header={false} width="50%"/>
                  <div className="flex flex-col items-center justify-center">
                    <div 
                      className="text-xl ml-2"
                      style={{
                        fontFamily: "'DM Sans', sans-serif",
                      }}>
                        Token : <strong>{genToken && genToken}</strong>
                    </div>
                    <div className="text-center ">
                      <input
                        className="text-center bg-white border rounded-xl border-gray-200 mt-2 mb-2 p-2 w-full"
                        type="text"
                        placeholder="Ketikkan Token disini"
                        aria-label=""
                        name="token"
                        id="token"
                        value={token}
                        autoComplete="off"
                        style={{fontSize: "14px"}}
                        onChange={handleToken}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            toInputToken();
                          }
                        }}
                      />
                      {hasError && (
                        <div className="text-sm text-red-600">
                          Token tidak valid !
                        </div>
                      )}
                    </div>
                    <div className="text-center">
                      <button
                        onClick={toInputToken}
                        style={{backgroundColor: "#4F8382", fontSize: "20px"}}
                        type="button"
                        id="btnSubmit"
                        className="bg-blue-500 hover:bg-blue-800 block text-white w-full rounded-xl px-10"
                      >
                        Mulai Tes
                      </button>
                    </div>
                  </div>
                </div>
              ): (
              <div className="md:flex flex-row justify-between">
                <div className="basis-2/4">
                  <div className="pt-2 text-center md:text-left">
                    <div className="italic text-sm">
                      {/* Tes Ke {Subtest && Subtest.urut} dari{" "} */}
                      Durasi Tes
                      {/* {Subtest && Subtest.jumlah_subtest} */}
                    </div>
                    <div className="font-bold">
                      {/* {Subtest && Subtest.nama_projek} */}
                      {Subtest && Subtest.durasi_ujian} Menit
                    </div>
                  </div>
                  <div className="pt-2 text-center md:text-left">
                    <div className="italic text-sm">Jumlah Soal</div>
                    {/* {listUjian != null && Subtest != null && listUjian[Subtest.urut - 1]?.jumlah_soal != null && (
                      <div className="font-bold">
                        {listUjian[Subtest.urut - 1].jumlah_soal} Soal
                      </div>
                    )} */}
                    {subtesPilihan?.jumlah_soal != null && (
                      <div className="font-bold">
                        {subtesPilihan.jumlah_soal} Soal
                      </div>
                    )}
                  </div>
                </div>
                <div className="basis-2/4 text-center">
                  <div className="pt-2">
                    <div className="italic text-sm">Token :</div>
                    {userData && userData.pengawas == 1 && false ? (
                      <div className="text-l font-bold">
                        Didapatkan dari Pengawas Ujian
                      </div>
                    ): (
                      <div className="text-6xl font-bold">
                      {genToken && genToken}
                    </div>
                    )}
                    <div className="text-center ">
                      <input
                        className="text-center bg-white border rounded-xl border-gray-200 mt-4 mb-2 p-2 w-2/5"
                        type="text"
                        placeholder="Ketikkan Token disini"
                        aria-label=""
                        name="token"
                        id="token"
                        value={token}
                        autoComplete="off"
                        style={{fontSize: "14px"}}
                        onChange={handleToken}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            toInputToken();
                          }
                        }}
                      />
                      {hasError && (
                        <div className="text-sm text-red-600">
                          Token tidak valid !
                        </div>
                      )}
                    </div>
                    <div className="text-center">
                      <button
                        onClick={toInputToken}
                        style={{backgroundColor: "#4F8382"}}
                        type="button"
                        id="btnSubmit"
                        className="bg-blue-500 hover:bg-blue-800 text-white py-2 w-1/3 rounded-full"
                      >
                        Mulai Tes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
              </form>
            </div>
          </div>
        </div>
      </NoCopyText>
    </div>
  );
}

export default KonfirmasiToken;
